/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lang_Suggestion_SwitchInputs */

const en_lang_suggestion_switch = /** @type {(inputs: Lang_Suggestion_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch`)
};

const ar_lang_suggestion_switch = /** @type {(inputs: Lang_Suggestion_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تبديل`)
};

const bn_lang_suggestion_switch = /** @type {(inputs: Lang_Suggestion_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বদলান`)
};

const de_lang_suggestion_switch = /** @type {(inputs: Lang_Suggestion_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wechseln`)
};

const es_lang_suggestion_switch = /** @type {(inputs: Lang_Suggestion_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar`)
};

const fr_lang_suggestion_switch = /** @type {(inputs: Lang_Suggestion_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer`)
};

const pt_lang_suggestion_switch = /** @type {(inputs: Lang_Suggestion_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudar`)
};

const zh_lang_suggestion_switch = /** @type {(inputs: Lang_Suggestion_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换`)
};

const tr_lang_suggestion_switch = /** @type {(inputs: Lang_Suggestion_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değiştir`)
};

const ru_lang_suggestion_switch = /** @type {(inputs: Lang_Suggestion_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить`)
};

const pl_lang_suggestion_switch = /** @type {(inputs: Lang_Suggestion_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmień`)
};

/**
* | output |
* | --- |
* | "Switch" |
*
* @param {Lang_Suggestion_SwitchInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const lang_suggestion_switch = /** @type {((inputs?: Lang_Suggestion_SwitchInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lang_Suggestion_SwitchInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_lang_suggestion_switch(inputs)
	if (locale === "bn") return bn_lang_suggestion_switch(inputs)
	if (locale === "de") return de_lang_suggestion_switch(inputs)
	if (locale === "es") return es_lang_suggestion_switch(inputs)
	if (locale === "fr") return fr_lang_suggestion_switch(inputs)
	if (locale === "pt") return pt_lang_suggestion_switch(inputs)
	if (locale === "zh") return zh_lang_suggestion_switch(inputs)
	if (locale === "tr") return tr_lang_suggestion_switch(inputs)
	if (locale === "ru") return ru_lang_suggestion_switch(inputs)
	if (locale === "pl") return pl_lang_suggestion_switch(inputs)
	return en_lang_suggestion_switch(inputs)
});